export default {
  header: {
    signIn: 'साइन इन',
    signUp: 'साइन अप'
  },
  userMenu: {
    wallet: 'वॉलेट',
    withdraw: 'निकासी',
    transaction: 'लेन-देन',
    myBet: 'मेरी बेट',
    rollover: 'रोलओवर',
    vault: 'तिजोरी',
    profile: 'प्रोफ़ाइल',
    settings: 'सेटिंग्स',
    signOut: 'साइन आउट',
    signOutTitle: 'साइन आउट',
    signOutContent: 'पुरस्कारों और रोमांचक खेलों से भरी दुनिया का अन्वेषण करें!',
    signOutConfirm: 'साइन आउट',
    cancel: 'रद्द करें'
  }
};
